import React from 'react'
import { makeStyles, Divider as MuiDivider } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, DividerProps>(
  (theme) => ({
    root: {},
    divider: (props) => ({
      borderBottom: `2px solid ${theme.palette.grey[props?.greyValue ?? 200]}`,
      margin: theme.spacing(1, 0)
    })
  }),
  { name: 'Divider' }
)

export interface DividerProps {
  classes?: StyleClasses<typeof useStyles>
  greyValue?: number | string
}

function Divider(props: DividerProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <MuiDivider className={classes.divider} />
    </div>
  )
}

export default Divider
